var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 2.92893C3.85827 2.00035 4.96067 1.26375 6.17392 0.761204C7.38718 0.258657 8.68754 -1.39397e-07 10.0008 0C11.314 1.39397e-07 12.6143 0.258658 13.8276 0.761205C15.0408 1.26375 16.1432 2.00035 17.0718 2.92893C18.0004 3.85752 18.737 4.95991 19.2396 6.17317C19.7421 7.38642 20.0008 8.68678 20.0008 10C20.0008 11.3132 19.7421 12.6136 19.2395 13.8268C18.737 15.0401 18.0004 16.1425 17.0718 17.0711L2.92969 2.92893Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34315 15.6569C7.46734 18.781 12.5327 18.781 15.6569 15.6569C18.781 12.5327 18.781 7.46734 15.6569 4.34315C12.5327 1.21895 7.46734 1.21895 4.34315 4.34315C1.21895 7.46734 1.21895 12.5327 4.34315 15.6569ZM2.92893 17.0711C6.83418 20.9763 13.1658 20.9763 17.0711 17.0711C20.9763 13.1658 20.9763 6.83418 17.0711 2.92893C13.1658 -0.976311 6.83418 -0.976311 2.92893 2.92893C-0.976311 6.83418 -0.976311 13.1658 2.92893 17.0711Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0645 6.93587C13.4551 7.32639 13.4551 7.95956 13.0645 8.35008L8.35048 13.0641C7.95996 13.4546 7.32679 13.4546 6.93627 13.0641C6.54575 12.6736 6.54575 12.0404 6.93627 11.6499L11.6503 6.93587C12.0408 6.54534 12.674 6.54534 13.0645 6.93587Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0644 13.064C12.6739 13.4546 12.0407 13.4546 11.6502 13.064L6.93612 8.34999C6.5456 7.95947 6.5456 7.32631 6.93612 6.93578C7.32664 6.54526 7.95981 6.54526 8.35033 6.93578L13.0644 11.6498C13.4549 12.0404 13.4549 12.6735 13.0644 13.064Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5f65ac178e048063a114deae4fec3afd.svg";
export { ForwardRef as ReactComponent };